module.exports = __webpack_public_path__ + "img/holiday.a8497000.jpeg";